import { Component, OnInit } from "@angular/core";
import { IOption } from "ng-select";
import { BsModalRef, BsModalService } from "ngx-bootstrap";
import { NgxSpinnerService } from "ngx-spinner";
import { SafetyAlertModalComponent } from "../safety-alert-modal/safety-alert-modal.component";
import { HelperService } from "../services/helper.service";
import { RilrService } from "../services/rilr.service";

import {API_URL } from '../config';

@Component({
  selector: "app-report-rir-print-preview-audit",
  templateUrl: "./report-rir-print-preview-audit.component.html",
  styleUrls: ["./report-rir-print-preview-audit.component.scss"],
  providers: [RilrService, HelperService],
})
export class ReportRirPrintPreviewAuditComponent implements OnInit {

  url: any;

  public masterData: any = {};
  agendaData: any[] = [];
 // masterData.agenda:any[];
  public templateData: any = {};
  public incidentColspan: number = 0;
  public reportSystemID: number;
  public documentSystemID: number;
  public documentTypeLabel: string = "incident report";
  public incidentTypeArr= [];
  public incidentTypeArrAll= [];
  public companySystemID = this.helperService.getSelectedCompanyId();
  public incidentCategoryArr: any[];
  public reportCategoryArr: any[];
  public incidentSubCategoryArr: any[];
  public incidentSubCategoryDynamicArr: any[];
  public correctiveActionsTbl: any = [];
  public auditorsInformationTbl: any = [];
  public meetingAttendees: any = [];
  public meetingClientsAndContractors: any = [];
  public injuredDetails: any = [];
  public immediateCauses: any = [];
  public rootCauses: any = [];
  public incidentCost: any = [];
  public reportCheckList: any = [];
  public typeOfEvent: any = [];
  public reportCheckListCategory: any = {};
  public checklistGuidelines: any = {};
  public materialItemsArr: any[];
  public specificationItemsArr: any[];
  public specificationCodes: any[];
  public parameterTypes: any[];
  yesNoArr1: any = [
    { value: 1, label: "No" },
    { value: 2, label: "Yes" },
  ];
  public methodEvacuation: any = [
    { value: 1, label: "Manual activation of alarm at fire indicator board" },
    { value: 2, label: "Other" },
  ];
  ESPOperationsInternalAuditChecklist: any = [
    { id: 1, segment: 46, header: "Compliance HSE" },
    { id: 2, segment: 47, header: "Compliance: Service Quality" },
    { id: 3, segment: 48, header: "Compliance: Equipment Handling" },
    { id: 4, segment: 49, header: "Compliance: Job Preparation" },
    { id: 5, segment: 50, header: "Compliance: Cable Spooler" },
    { id: 6, segment: 51, header: "Compliance: Cable Splicing" },
    { id: 7, segment: 52, header: "Compliance: General Installation" },
    { id: 8, segment: 53, header: "Compliance: Installation" },
    { id: 9, segment: 54, header: "Compliance: Pull-out" },
    { id: 10, segment: 55, header: "Compliance: Commissioning" },
    { id: 11, segment: 56, header: "Compliance: Documentation" },
  ];

  segmentOneYes: number = 0;
  segmentTwoYes: number = 0;
  segmentThreeYes: number = 0;
  segmentFourYes: number = 0;
  segmentFiveYes: number = 0;
  segmentSixYes: number = 0;
  segmentSevenYes: number = 0;
  segmentEightYes: number = 0;
  segmentNineYes: number = 0;
  segmentTenYes: number = 0;
  segmentElevenYes: number = 0;
  segmentYesTotal: number = 0;
  segmentOneNOH: number = 0;
  segmentTwoNOH: number = 0;
  segmentThreeNOH: number = 0;
  segmentFourNOH: number = 0;
  segmentFiveNOH: number = 0;
  segmentSixNOH: number = 0;
  segmentSevenNOH: number = 0;
  segmentEightNOH: number = 0;
  segmentNineNOH: number = 0;
  segmentTenNOH: number = 0;
  segmentElevenNOH: number = 0;
  segmentNOHTotal: number = 0;
  segmentOneNOM: number = 0;
  segmentTwoNOM: number = 0;
  segmentThreeNOM: number = 0;
  segmentFourNOM: number = 0;
  segmentFiveNOM: number = 0;
  segmentSixNOM: number = 0;
  segmentSevenNOM: number = 0;
  segmentEightNOM: number = 0;
  segmentNineNOM: number = 0;
  segmentTenNOM: number = 0;
  segmentElevenNOM: number = 0;
  segmentNOMTotal: number = 0;
  segmentOneNOL: number = 0;
  segmentTwoNOL: number = 0;
  segmentThreeNOL: number = 0;
  segmentFourNOL: number = 0;
  segmentFiveNOL: number = 0;
  segmentSixNOL: number = 0;
  segmentSevenNOL: number = 0;
  segmentEightNOL: number = 0;
  segmentNineNOL: number = 0;
  segmentTenNOL: number = 0;
  segmentElevenNOL: number = 0;
  segmentNOLTotal: number = 0;
  segmentOneNA: number = 0;
  segmentTwoNA: number = 0;
  segmentThreeNA: number = 0;
  segmentFourNA: number = 0;
  segmentFiveNA: number = 0;
  segmentSixNA: number = 0;
  segmentSevenNA: number = 0;
  segmentEightNA: number = 0;
  segmentNineNA: number = 0;
  segmentTenNA: number = 0;
  segmentElevenNA: number = 0;
  segmentNATotal: number = 0;

  segmentOnePer: number = 0;
  segmentTwoPer: number = 0;
  segmentThreePer: number = 0;
  segmentFourPer: number = 0;
  segmentFivePer: number = 0;
  segmentSixPer: number = 0;
  segmentSevenPer: number = 0;
  segmentEightPer: number = 0;
  segmentNinePer: number = 0;
  segmentTenPer: number = 0;
  segmentElevenPer: number = 0;
  segmentPerTotal: number = 0;

  yellowColorCode: boolean = false;
  orangeColorCode: boolean = false;
  redColorCode: boolean = false;

  bsModalRefPrint: BsModalRef;

  checklistColumnsArr: any[];
  checklistCriteriaScoreArr: any[];
  summarizedChecklist: any = [];
  summarizedChecklistTot: any = [];
  public incidentCautionsArrLeft: any[];

  public investigationCriticalArr: any = [];
  public causationalFactorArr: any = [];
  public unsafeActionsArr: any = [];
  public unsafeConditionsArr: any = [];
  public underlyingCausesArr: any = [];
  public managementSystemArr: any = [];
  public immediateActionsArr: any = [];

    public incidentNotificationMultipleOneArr: any = [];
    public incidentNotificationMultipleTwoArr: any = [];
    public incidentNotificationMultipleEightArr: any[];

  constructor(
    public bsModalRef: BsModalRef,
    private helperService: HelperService,
    private modalService: BsModalService,
    private spinner: NgxSpinnerService,
    private rilrService: RilrService
  ) {}

  ngOnInit() {
    this.spinner.show();
    setTimeout(() => {
      this.reportPrintPreview();
      this.templateAssignedRoute("Print");
    }, 0);

    this.url=API_URL+'/';
  }


  public formatActionDescription(description: string): string {
    //console.log(description.replace(/\n/g, '<br>'));
    return description.replace(/\n/g, '<br>');
}



  public templateAssignedRoute(crudType) {
    const that = this;
    that.rilrService
      .getTemplateAssignedRoute()
      .get({
        crudType: crudType,
        documentSystemID: that.documentSystemID,
        companySystemID: that.helperService.getSelectedCompanyId()
      })
      .subscribe(
        (output) => {
          const resp = output.data.data;
          that.templateData = resp;
        },
        () => {}
      );
  }

 // agenda:any[]=[];
 itemNames: any;
 masterDataAuditName: any;

  public reportPrintPreview() {
    const that = this;
    that.rilrService
      .reportPrintPreviewData()
      .get({
        companySystemID: that.companySystemID,
        reportSystemID: that.reportSystemID,
        documentSystemID: that.documentSystemID,
      })
      .subscribe(
        (data) => {
          const resp = data.data.data;
          //console.log(resp);
          that.incidentTypeArr = that.helperService.incidentsIdChangeToInt(
            resp.incidents
          );
          that.incidentTypeArrAll = that.helperService.incidentsIdChangeToInt(resp.incidentsAll);
          that.reportCheckListCategory = resp.reportCheckListCategory;
          that.incidentCategoryArr = resp.incidentCategory;
          that.reportCategoryArr = resp.reportCategory;
          that.incidentSubCategoryArr = resp.IncidentSubCategory;
         
          that.masterData = resp.reportData;
          // //console.log(that.masterData);
          // that.masterDataAuditName = that.masterData.submiited_by.empName;
          // //console.log(that.masterDataAuditName);

          if (that.masterData.submiited_by && that.masterData.submiited_by.empName !== null) {
            that.masterDataAuditName = that.masterData.submiited_by.empName;
            //console.log(that.masterDataAuditName);
          } else {
            //console.log("submiited_by empName is null");
          }



          const auditCriteriaArray = JSON.parse(that.masterData.audit_citeria_id);
        if (auditCriteriaArray && auditCriteriaArray.length > 0) {
          that.itemNames = auditCriteriaArray.map(item => item.itemName);
          //console.log(that.itemNames); // This will log an array of itemName values
        }


        //  that.agenda=resp.reportData.agenda; 

        if(that.masterData.agenda != '' ||that.masterData.agenda !='[]' ||that.masterData.agenda != null){
        //  that.dataagenda=  JSON.parse(that.masterData.agenda) ;
          that.agendaData=  JSON.parse(that.masterData.agenda) ;
        }
        else{
          that.agendaData= [];
        }


          // if(that.masterData.agenda != '' ||that.masterData.agenda !='[]' ||that.masterData.agenda != null){
          //   that.agendaData=  JSON.parse(that.masterData.agenda) ;
           
          // }





          that.incidentSubCategoryDynamicArr = resp.incidentDynamicSubCategory;
          that.correctiveActionsTbl = resp.actions;
          //console.log(that.correctiveActionsTbl);



          that.auditorsInformationTbl = resp.auditorDetails;
          that.documentTypeLabel = resp.document.documentDescription;
          that.meetingAttendees = resp.meetingAttendees;
          that.meetingClientsAndContractors = resp.meetingClientsAndContractors;
          that.injuredDetails = resp.injuredDetails;
          that.immediateCauses = resp.immediateCauses;
          that.rootCauses = resp.rootCauses;
          that.incidentCost = resp.incidentCost;
          that.reportCheckList = resp.reportCheckList;
          that.checklistColumnsArr = resp.headerColumns;
          that.checklistCriteriaScoreArr = resp.summarizedScore;
          that.summarizedChecklist = resp.summarizedData;
          that.summarizedChecklistTot = resp.headerTotal;
          that.checklistGuidelines = resp.checklistGuidelines;
          that.investigationCriticalArr = resp.criticalFactors;
          that.causationalFactorArr = resp.causationalFactor;
          that.unsafeActionsArr = resp.unsafeActions;
          that.unsafeConditionsArr = resp.unsafeConditions;
          that.underlyingCausesArr = resp.underlyingCauses;
          that.managementSystemArr = resp.managementSystem;
          that.immediateActionsArr = resp.immediateActions;
          that.incidentNotificationMultipleOneArr = resp.detailOne;
          that.incidentNotificationMultipleTwoArr = resp.detailTwo;
          that.incidentNotificationMultipleEightArr = resp.detailEight;
          that.incidentCautionsArrLeft = resp.incidentCautionsLeft;
          that.materialItemsArr = resp.materialItems;   
          that.specificationCodes = resp.specs; 
          that.parameterTypes = resp.specs_parameter; 
          that.specificationItemsArr = resp.specsGroup;   
          let z = 0;
          for (var index = 0; index < resp.headerColumns.length; index++) {
            if (resp.headerColumns[index]["columnTypeID"] == 2 || resp.headerColumns[index]["columnTypeID"] == 3) {
              resp.headerColumns[index]["text"] = z + 1;
              z++;
            }
          }
          let m = 0;
          for (var index = 0; index < resp.headerColumns.length; index++) {
            if (resp.headerColumns[index]["columnTypeID"] == 5) {
              resp.headerColumns[index]["textCheck"] = m + 1;
              m++;
            }
          }
        
          that.checklistColumnsArr = resp.headerColumns;
          that.typeOfEvent = resp.typeOfEvent;

          if (that.documentSystemID == 2) {
            that.getAuditReportSummary();
          }

   
          setTimeout(() => {
            if(!that.incidentTypeArr.some((incident) => incident.id == that.masterData.reportNewSystemID)){
              let incidentIndex = that.incidentTypeArrAll.findIndex(i => i.id == that.masterData.reportNewSystemID)
              if(incidentIndex > -1){
                that.incidentTypeArr.push(that.incidentTypeArrAll[incidentIndex])
              }
            }
            that.incidentColspan = that.incidentTypeArr.length;
          }, 0);
          that.spinner.hide();
        },
        (error) => {
          that.spinner.hide();
        }
      );


  }

  objectKeys(obj) { 
    return Object.keys(obj);
  }

  public getAuditReportSummary() {
    const that = this;
    that.rilrService
      .getAuditReportSummaryAlkhorayef()
      .get({
        reportSystemID: that.reportSystemID,
        documentSystemID: that.documentSystemID,
      })
      .subscribe(
        (resp) => {
          const temp = resp.data.data;
          that.segmentOneYes = temp.segmentOneYes[0]["segmentTotal"];
          that.segmentTwoYes = temp.segmentTwoYes[0]["segmentTotal"];
          that.segmentThreeYes = temp.segmentThreeYes[0]["segmentTotal"];
          that.segmentFourYes = temp.segmentFourYes[0]["segmentTotal"];
          that.segmentFiveYes = temp.segmentFiveYes[0]["segmentTotal"];
          that.segmentSixYes = temp.segmentSixYes[0]["segmentTotal"];
          that.segmentSevenYes = temp.segmentSevenYes[0]["segmentTotal"];
          that.segmentEightYes = temp.segmentEightYes[0]["segmentTotal"];
          that.segmentNineYes = temp.segmentNineYes[0]["segmentTotal"];
          that.segmentTenYes = temp.segmentTenYes[0]["segmentTotal"];
          that.segmentElevenYes = temp.segmentElevenYes[0]["segmentTotal"];
          that.segmentYesTotal =
            that.segmentOneYes +
            that.segmentTwoYes +
            that.segmentThreeYes +
            that.segmentFourYes +
            that.segmentFiveYes +
            that.segmentSixYes +
            that.segmentSevenYes +
            that.segmentEightYes +
            that.segmentNineYes +
            that.segmentTenYes +
            that.segmentElevenYes;

          that.segmentOnePer = (that.segmentOneYes / 17) * 100;
          that.segmentTwoPer = (that.segmentTwoYes / 17) * 100;
          that.segmentThreePer = (that.segmentThreeYes / 12) * 100;
          that.segmentFourPer = (that.segmentFourYes / 25) * 100;
          that.segmentFivePer = (that.segmentFiveYes / 19) * 100;
          that.segmentSixPer = (that.segmentSixYes / 30) * 100;
          that.segmentSevenPer = (that.segmentSevenYes / 14) * 100;
          that.segmentEightPer = (that.segmentEightYes / 42) * 100;
          that.segmentNinePer = (that.segmentNineYes / 17) * 100;
          that.segmentTenPer = (that.segmentTenYes / 43) * 100;
          that.segmentElevenPer = (that.segmentElevenYes / 21) * 100;
          that.segmentPerTotal = (that.segmentYesTotal / 257) * 100;

          that.segmentOneNOH = temp.segmentOneYes[1]["segmentTotal"];
          that.segmentTwoNOH = temp.segmentTwoYes[1]["segmentTotal"];
          that.segmentThreeNOH = temp.segmentThreeYes[1]["segmentTotal"];
          that.segmentFourNOH = temp.segmentFourYes[1]["segmentTotal"];
          that.segmentFiveNOH = temp.segmentFiveYes[1]["segmentTotal"];
          that.segmentSixNOH = temp.segmentSixYes[1]["segmentTotal"];
          that.segmentSevenNOH = temp.segmentSevenYes[1]["segmentTotal"];
          that.segmentEightNOH = temp.segmentEightYes[1]["segmentTotal"];
          that.segmentNineNOH = temp.segmentNineYes[1]["segmentTotal"];
          that.segmentTenNOH = temp.segmentTenYes[1]["segmentTotal"];
          that.segmentElevenNOH = temp.segmentElevenYes[1]["segmentTotal"];

          that.segmentNOHTotal =
            that.segmentOneNOH +
            that.segmentTwoNOH +
            that.segmentThreeNOH +
            that.segmentFourNOH +
            that.segmentFiveNOH +
            that.segmentSixNOH +
            that.segmentSevenNOH +
            that.segmentEightNOH +
            that.segmentNineNOH +
            that.segmentTenNOH +
            that.segmentElevenNOH;

          that.segmentOneNOM = temp.segmentOneYes[2]["segmentTotal"];
          that.segmentTwoNOM = temp.segmentTwoYes[2]["segmentTotal"];
          that.segmentThreeNOM = temp.segmentThreeYes[2]["segmentTotal"];
          that.segmentFourNOM = temp.segmentFourYes[2]["segmentTotal"];
          that.segmentFiveNOM = temp.segmentFiveYes[2]["segmentTotal"];
          that.segmentSixNOM = temp.segmentSixYes[2]["segmentTotal"];
          that.segmentSevenNOM = temp.segmentSevenYes[2]["segmentTotal"];
          that.segmentEightNOM = temp.segmentEightYes[2]["segmentTotal"];
          that.segmentNineNOM = temp.segmentNineYes[2]["segmentTotal"];
          that.segmentTenNOM = temp.segmentTenYes[2]["segmentTotal"];
          that.segmentElevenNOM = temp.segmentElevenYes[2]["segmentTotal"];

          that.segmentNOMTotal =
            that.segmentOneNOM +
            that.segmentTwoNOM +
            that.segmentThreeNOM +
            that.segmentFourNOM +
            that.segmentFiveNOM +
            that.segmentSixNOM +
            that.segmentSevenNOM +
            that.segmentEightNOM +
            that.segmentNineNOM +
            that.segmentTenNOM +
            that.segmentElevenNOM;

          that.segmentOneNOL = temp.segmentOneYes[3]["segmentTotal"];
          that.segmentTwoNOL = temp.segmentTwoYes[3]["segmentTotal"];
          that.segmentThreeNOL = temp.segmentThreeYes[3]["segmentTotal"];
          that.segmentFourNOL = temp.segmentFourYes[3]["segmentTotal"];
          that.segmentFiveNOL = temp.segmentFiveYes[3]["segmentTotal"];
          that.segmentSixNOL = temp.segmentSixYes[3]["segmentTotal"];
          that.segmentSevenNOL = temp.segmentSevenYes[3]["segmentTotal"];
          that.segmentEightNOL = temp.segmentEightYes[3]["segmentTotal"];
          that.segmentNineNOL = temp.segmentNineYes[3]["segmentTotal"];
          that.segmentTenNOL = temp.segmentTenYes[3]["segmentTotal"];
          that.segmentElevenNOL = temp.segmentElevenYes[3]["segmentTotal"];

          that.segmentNOLTotal =
            that.segmentOneNOL +
            that.segmentTwoNOL +
            that.segmentThreeNOL +
            that.segmentFourNOL +
            that.segmentFiveNOL +
            that.segmentSixNOL +
            that.segmentSevenNOL +
            that.segmentEightNOL +
            that.segmentNineNOL +
            that.segmentTenNOL +
            that.segmentElevenNOL;

          that.segmentOneNA = temp.segmentOneYes[4]["segmentTotal"];
          that.segmentTwoNA = temp.segmentTwoYes[4]["segmentTotal"];
          that.segmentThreeNA = temp.segmentThreeYes[4]["segmentTotal"];
          that.segmentFourNA = temp.segmentFourYes[4]["segmentTotal"];
          that.segmentFiveNA = temp.segmentFiveYes[4]["segmentTotal"];
          that.segmentSixNA = temp.segmentSixYes[4]["segmentTotal"];
          that.segmentSevenNA = temp.segmentSevenYes[4]["segmentTotal"];
          that.segmentEightNA = temp.segmentEightYes[4]["segmentTotal"];
          that.segmentNineNA = temp.segmentNineYes[4]["segmentTotal"];
          that.segmentTenNA = temp.segmentTenYes[4]["segmentTotal"];
          that.segmentElevenNA = temp.segmentElevenYes[4]["segmentTotal"];

          that.segmentNATotal =
            that.segmentOneNA +
            that.segmentTwoNA +
            that.segmentThreeNA +
            that.segmentFourNA +
            that.segmentFiveNA +
            that.segmentSixNA +
            that.segmentSevenNA +
            that.segmentEightNA +
            that.segmentNineNA +
            that.segmentTenNA +
            that.segmentElevenNA;
          that.getSummaryColorCalculater();
        },
        (error) => {}
      );
  }

 convertId(input: any): any {
    //console.log(input);
    // Define the conditions based on the requirements
    if (input === "4") {
      return "6";
    } else if (input === "5") {
      return "7";
    } else if (input === "6") {
      return "8";
    } else {
      // Handle other cases or provide a default value if needed
      return -1; // Example default value
    }
  }



  
  public getSummaryColorCalculater() {
    const that = this;
    if (
      that.segmentNOHTotal <= 3 ||
      that.segmentNOMTotal <= 6 ||
      that.segmentNOLTotal <= 8
    ) {
      that.yellowColorCode = true;
      return false;
    } else if (
      that.segmentNOHTotal > 3 ||
      that.segmentNOMTotal > 6 ||
      that.segmentNOLTotal > 8
    ) {
      that.orangeColorCode = true;
      return false;
    } else if (
      that.segmentNOHTotal > 5 ||
      that.segmentNOMTotal > 8 ||
      that.segmentNOLTotal > 10
    ) {
      that.redColorCode = true;
      return false;
    }
  }

  public closeModal() {
    this.bsModalRef.hide();
  }

  public print_pdf_preview() {
    // const urlGeneratingPdf = 'api/v1/printReportPDF?id=' + this.reportSystemID + '&documentSystemID=' + this.documentSystemID + '&companySystemID=' + this.companySystemID;
    //  window.open(urlGeneratingPdf, '_blank');
    const that = this;
    that.rilrService
      .printRIRReportPDFAudit()
      .get({
        id: that.reportSystemID,
        documentSystemID: that.documentSystemID,
        companySystemID: that.companySystemID,
      })
      .subscribe(
        (resp) => {
          const data = resp.data.data;
          // window.open(data.pdf_path, "_blank");
          window.open( this.url+data.pdf_path, "_blank");
        },
        (error) => {
          if (error.status == 500) {
            //that.tosterMessageService.showError("Error", error.data.message);
          }
        }
      );
  }

  public rowspanCalculator(segmentID) {
    if (
      segmentID == 57 ||
      segmentID == 60 ||
      segmentID == 62 ||
      segmentID == 63 ||
      segmentID == 67 ||
      segmentID == 69 ||
      segmentID == 71 ||
      segmentID == 73 ||
      segmentID == 75 ||
      segmentID == 77 ||
      segmentID == 79 ||
      segmentID == 81 ||
      segmentID == 83
    ) {
      return 1;
    } else if (segmentID == 58) {
      return 10;
    } else if (segmentID == 59 || segmentID == 70 || segmentID == 90) {
      return 4;
    } else if (
      segmentID == 61 ||
      segmentID == 64 ||
      segmentID == 72 ||
      segmentID == 74 ||
      segmentID == 76 ||
      segmentID == 82
    ) {
      return 3;
    } else if (segmentID == 66) {
      return 12;
    } else if (segmentID == 68) {
      return 7;
    } else if (segmentID == 78 || segmentID == 80) {
      return 2;
    }
  }

  public print_safety() {
    const that = this;
    that.bsModalRefPrint = that.modalService.show(SafetyAlertModalComponent, {
      class: "modal-xlg",
      backdrop: "static",
    });
    that.bsModalRefPrint.content.reportSystemID = that.reportSystemID;
  }
}



// WEBPACK FOOTER //
// /app/src/app/report-rir-print-preview-audit/report-rir-print-preview-audit.component.ts